<template>
  <div v-if="tooltipFromIcon && tooltipToIcon">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs"
               v-on="on"
               icon
               style="height: 40px; width: 40px">
          <v-icon v-bind="attrs"
                  v-on="on"
                  class="morph"
                  :color="color"
                  :size="size"
                  :style="style">{{ currentIcon }}</v-icon>
        </v-btn>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
  <div v-else>
    <v-icon class="morph"
            :color="color"
            :size="size"
            :style="style">{{ currentIcon }}</v-icon>
  </div>
</template>

<script>
export default {
  name: 'MorphIcon',
  props: {
    fromIcon: String, // materialdesign icon string, eg. mdi-chevron-left bound to the trigger value true
    toIcon: String, // materialdesign icon string, eg. mdi-chevron-left bound to the trigger value false
    tooltipFromIcon: { type: String, default: '' },
    tooltipToIcon: { type: String, default: '' },
    morphDuration: {
      type: Number,
      default: 500,
    },
    color: {
      type: String,
    },
    trigger: Boolean,
    size: { type: Number, default: 24 },
  },

  data() {
    return {
      currentIcon: this.trigger === false ? this.fromIcon : this.toIcon,

      style: { transition: `all ${this.morphDuration / 2}ms`, transform: 'scale(0.7)' },
      hintStyle: { visibility: 'hidden' },
    };
  },

  computed: {
    arrow() {
      return { background: 'red', width: '10px', height: '10px', transform: 'rotate(90deg)' };
    },
    tooltip() {
      return this.trigger === false ? this.tooltipFromIcon : this.tooltipToIcon;
    },
  },
  methods: {
    startMorph() {
      setTimeout(() => {
        this.style = { transition: `all ${this.morphDuration / 2}ms`, opacity: 1, transform: 'scaleX(0.7) scaleY(0.7) rotate(0deg)' };
        this.currentIcon = this.currentIcon === this.toIcon ? this.fromIcon : this.toIcon;
        this.hintStyle.visibility = 'visible';
        setTimeout(() => {
          this.hintStyle.visibility = 'hidden';
        }, 5000);
      }, this.morphDuration / 2);

      this.style = { transition: `all ${this.morphDuration / 2}ms`, opacity: 0, transform: `scaleX(0.2) scaleY(0.5) rotate(45deg)` };
    },
  },
  watch: {
    trigger(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentIcon = oldValue === false ? this.fromIcon : this.toIcon;

        this.startMorph();
      }
    },
  },
};
</script>

<style scoped>
.morph {
  transition: transform 500ms ease-in-out;
}
.hint {
  background: red;
  border-radius: 5px;
  padding: 4px;
  color: white;
  position: absolute;
  top: -20px;
  left: 20px;
  transition: all 500ms ease-in-out;
}
</style>
